import { Injectable } from "@angular/core";
import { RelatorioVistoriaController } from "app/controllers/mob/relatorio-vistoria.controller";
import { RelatorioVistoriaDTO, RelatorioVistoriaListDTO } from "app/model/dtos/mob/relatorio-vistoria.dto";
import { LoaderService } from "../loader.service";
import { VistoriaSearch } from "./vistoria.search";
import { PagedResponse } from "app/interfaces/paged-response.inteface";

@Injectable()
export class RelatorioVistoriaService {
    constructor(
        private _relatorioVistoriaController: RelatorioVistoriaController,
        private _loaderService: LoaderService
    ) { }
    async findVistoria(vistoriaSearch?: VistoriaSearch): Promise<PagedResponse<RelatorioVistoriaDTO>> {
        this._loaderService.show()
        try {
            return await this._relatorioVistoriaController.findVistoria(vistoriaSearch && vistoriaSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }

    async vistoria( vistoriaSearch: VistoriaSearch):Promise<Blob> {
        this._loaderService.show();
        try {
            return await this._relatorioVistoriaController.vistoria(( vistoriaSearch && vistoriaSearch.getFilters()) || null).finally( () => this._loaderService.hide())
        } catch( error ) {
            this._loaderService.hide();
            return null
        }
    }

    async vistoriaDefeitos(vistoriaSearch: VistoriaSearch): Promise<Blob> {
        this._loaderService.show();
        return await this._relatorioVistoriaController.vistoriaDefeitos((vistoriaSearch && vistoriaSearch.getFilters()) || null).finally(() => this._loaderService.hide())
    }

    async itensReprovados( vistoriaSearch: VistoriaSearch):Promise<Blob> {
        this._loaderService.show();
        try {
            return await this._relatorioVistoriaController.itensReprovados(( vistoriaSearch && vistoriaSearch.getFilters()) || null).finally( () => this._loaderService.hide())
        } catch( error ) {
            this._loaderService.hide();
            return null
        }
    }
}